import { ThemeToggle } from "@/components/ui/ThemeToggle"
import { TopNav } from "@/components/navigation/TopNav"
import { WorkspaceSidebar } from "@/components/navigation/WorkspaceSidebar"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { SubscriptionProvider } from "@/contexts/SubscriptionContext"
import { PlansInfo } from "@/components/plans/PlansInfo"

const Subscriptions = () => {
  return (
    <SubscriptionProvider>
      <SidebarProvider>
        <div className="min-h-screen w-full">
          <div className="fixed top-0 left-0 right-0 z-50">
            <TopNav />
          </div>
          <div className="flex pt-14">
            <WorkspaceSidebar />
            <SidebarInset className="w-full">
              <div className="relative p-6">
                <div className="absolute right-8 top-8">
                  <ThemeToggle />
                </div>
                <PlansInfo />
              </div>
            </SidebarInset>
          </div>
        </div>
      </SidebarProvider>
    </SubscriptionProvider>
  )
}

export default Subscriptions